import React, { useState } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { Link, useNavigate } from 'react-router-dom'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'

const Create = () => {
    const navigate = useNavigate()
    const [errors, setErrors] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [page, setPage] = useState({ value: '', error: false })
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

    // Handle image
    const handleImage = event => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 1000) {
                setErrors({ ...errors, image: 'Select less than 1000KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })
            setErrors({ ...errors, image: null })
        }
    }

    // Submit Form
    const onSubmit = async (event) => {
        event.preventDefault()
        if (!page.value) return setPage({ ...page, error: true })
        if (!selectedFile) return setErrors({ ...errors, image: 'Image is required' })

        let formData = new FormData()
        formData.append('page', page.value)
        formData.append('image', selectedFile.image)

        setLoading(true)
        await Requests.Addsense.Store(formData, header)
        setLoading(false)
        navigate("/dashboard/marketing/web-ad")
    }

    return (
        <div className="store-addsense pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Add Addsense</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/marketing/web-ad"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={onSubmit}>

                                    {/* page */}
                                    <div className="form-group mb-4">
                                        {page.error ? <p className="text-danger">page is required.</p> : <p>Select page</p>}
                                        <select
                                            className="form-control shadow-none"
                                            onChange={event => setPage({ value: event.target.value, error: false })}
                                        >
                                            <option defaultValue={""}>--</option>
                                            <option value="clientDashboard">Client Dashboard (260px * auto) </option>
                                            <option value="adminDashboard">Admin Dashboard </option>
                                            <option value="gotokDashboard">gotok Dashboard </option>
                                            <option value="singleProfile">Single Profile</option>
                                            <option value="timelineContainer">Timeline Container</option>
                                            <option value="timelineSide">Timeline Side</option>
                                        </select>
                                    </div>

                                    {/* Image upload Container */}
                                    <div className="form-group mb-4">
                                        {errors && errors.image ? <p className="text-danger">{errors.image}</p> : <p>Image</p>}
                                        <div className="d-flex">
                                            {selectedFile && selectedFile.preview ?
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                    </div>
                                                </div>
                                                : null}

                                            <div className="img-container text-center">
                                                <div className="image-plus border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {isLoading ? 'Submitting...' : 'Submit'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Create;